import React from "react";
import ProjectCard from "../../components/Project/ProjectCard";
import projectList from "../project/projectList";
const Project = () => {

  var projectsData = [
    {
      id: 0,
      category: "Express Logistics",
      title: "Delivering success through logistics",
      content: "Diverse Solutions, One Trusted Team",
      link: "/elevators",
},
    ...projectList.slice(0, 5).map((item, index) => ({
    id: index + 1,
    image: item.basicInfo.image,
    content: item.basicInfo.content,
    category: item.basicInfo.category,
    title: item.details.title,
    link: `/elevator-details/${item.id}`,
  })),
];

  

  return (
    <>
      {/*Project Two Start*/}
      <ProjectCard projects={projectsData} />
      {/*Project Two End*/}
    </>
  );
};

export default Project;
